import { langs } from './languages';

const supported = Object.keys(langs);

// Active language code ('en' default), from the server-injected global or the first path segment.
export function getLangCode(): string {
  if (typeof window === 'undefined') return 'en';
  const injected = (window as unknown as { __SAC_LANG__?: string }).__SAC_LANG__;
  if (injected && supported.includes(injected)) return injected;
  const seg = window.location.pathname.split('/')[1];
  return /^[a-z]{2}$/.test(seg) && supported.includes(seg) && seg !== 'en' ? seg : 'en';
}

// '' for English, '/xx' otherwise — used as the react-router basename.
export function getLangBasename(): string {
  const code = getLangCode();
  return code === 'en' ? '' : `/${code}`;
}

// Locale-prefixed path for raw anchors and copied links (react-router Links
// get the prefix automatically via the router basename).
export function localUrl(path: string): string {
  return `${getLangBasename()}${path}`;
}
